// Lite — Trigger
export const NPS_TRIGGER_REQUEST = '@nps/NPS_TRIGGER_REQUEST';
export const NPS_TRIGGER_SUCCESS = '@nps/NPS_TRIGGER_SUCCESS';
export const NPS_TRIGGER_FAILURE = '@nps/NPS_TRIGGER_FAILURE';

// Lite — Questionnaire
export const NPS_QUESTIONNAIRE_REQUEST = '@nps/NPS_QUESTIONNAIRE_REQUEST';
export const NPS_QUESTIONNAIRE_SUCCESS = '@nps/NPS_QUESTIONNAIRE_SUCCESS';
export const NPS_QUESTIONNAIRE_FAILURE = '@nps/NPS_QUESTIONNAIRE_FAILURE';

// Lite — Modal control
export const NPS_OPEN_MODAL = '@nps/NPS_OPEN_MODAL';
export const NPS_CLOSE_MODAL = '@nps/NPS_CLOSE_MODAL';

// Lite — Submit
export const NPS_SUBMIT_REQUEST = '@nps/NPS_SUBMIT_REQUEST';
export const NPS_SUBMIT_SUCCESS = '@nps/NPS_SUBMIT_SUCCESS';
export const NPS_SUBMIT_FAILURE = '@nps/NPS_SUBMIT_FAILURE';

// Lite — Dismiss
export const NPS_DISMISS_REQUEST = '@nps/NPS_DISMISS_REQUEST';
export const NPS_DISMISS_SUCCESS = '@nps/NPS_DISMISS_SUCCESS';
export const NPS_DISMISS_FAILURE = '@nps/NPS_DISMISS_FAILURE';

// Lite — Session
export const NPS_RESET_SESSION = '@nps/NPS_RESET_SESSION';
export const NPS_SET_TRIGGER_SOURCE = '@nps/NPS_SET_TRIGGER_SOURCE';
export const NPS_SET_START_DATETIME = '@nps/NPS_SET_START_DATETIME';
